import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(2),
    backgroundColor: theme.palette.facet.whiteSmoke,
    borderRadius: theme.radius.md,
  },
});

const AssumptionSection = ({
  className,
  classes,
  fields,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {fields.map(field => (
        <MetaField attr={field} />
      ))}
    </Box>
  );
};

AssumptionSection.defaultProps = {
  className: '',
};

AssumptionSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
};

export default withStyles(styles)(AssumptionSection);
